export const httpError = (err, history, cb) => {
  if (err.status === 401) return history.push('/login')
  if (cb) return cb()
}
